module.exports = __webpack_public_path__ + "2de58d2a01ba26d8d31c2fe42878bd7c.svg";